import { IEmbedData } from "../types";

export const getStartSeconds = ({ startHour, startMinute, startSecond }: IEmbedData) => {
    let totalSeconds = (startHour || 0) * 60 * 60 + (startMinute || 0) * 60 + (startSecond || 0);
    return totalSeconds;
};

export const getEndSeconds = ({ endHour, endMinute, endSecond }: IEmbedData) => {
    let totalSeconds = (endHour || 0) * 60 * 60 + (endMinute || 0) * 60 + (endSecond || 0);
    return totalSeconds;
};